export const languages = ['Spanish', 'English', 'Other'];

export const gradeLevels = ['PK(3)', 'PK(4)', 'PK', 'K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'TK'];